
import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '../utils/cn';
import toast from 'react-hot-toast';

interface CopyButtonProps {
  text: string;
  className?: string;
  successMessage?: string;
  onCopy?: () => void;
}

export function CopyButton({ text, className, successMessage = 'Copied!', onCopy }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(successMessage);
      onCopy?.();
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy');
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1.5 text-sm',
        'bg-surface hover:bg-slate-700 border border-slate-700 rounded-lg',
        'text-slate-300 hover:text-white transition-colors',
        className
      )}
      title="Copy to clipboard"
    >
      {copied ? (
        <Check className="w-4 h-4 text-emerald-500" />
      ) : (
        <Copy className="w-4 h-4" />
      )}
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
}
